export default "__VITE_ASSET__Belqbx0c__"